import { Close16 } from '@carbon/icons-react';
import styled from 'styled-components';

const ModalBackdrop = styled.div`
  position: fixed;
  z-index: 500000000;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  position: fixed;
  z-index: 500000001;
  padding: 2rem;
  width: ${({ width }) => (width ? `${width}%` : '38%')};
  height: ${({ height }) => (height ? `${height}%` : '60%')};
  left: ${({ width }) => (width ? `${(100 - width) / 2}%` : '32%')};
  top: ${({ height }) => (height ? `${(100 - height) / 2}%` : '20%')};
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
`;

const Exit = styled(Close16)`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
`;

export { ModalBackdrop, ModalContainer, Exit };
